import { useTranslation } from "../i18n/i18n";
import StickyTitle from "../components/StickyTitle/StickyTitle";

const PrivacyPolicy = () => {
	const { translate } = useTranslation();
	const emailLink =
		"<a href='mailto:numerys.app@gmail.com' class='link-button'>numerys.app@gmail.com</a>";

	return (
		<div className="content">
			<StickyTitle title={translate("privacy.title")} />
			<div className="page-content">
				<p className="legal-updated">{translate("privacy.updated")}</p>

				<section className="legal-section">
					<h2 className="legal-title">{translate("privacy.sections.who")}</h2>
					<p
						dangerouslySetInnerHTML={{
							__html: translate("privacy.content.who", { emailLink }),
						}}
						className="legal-paragraph"
					/>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">{translate("privacy.sections.data")}</h2>
					<p className="legal-paragraph">{translate("privacy.content.data")}</p>
					<ul className="legal-list">
						<li>{translate("privacy.content.data.auth")}</li>
						<li>{translate("privacy.content.data.profile")}</li>
						<li>{translate("privacy.content.data.financial")}</li>
						<li>{translate("privacy.content.data.technical")}</li>
					</ul>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">
						{translate("privacy.sections.hosting")}
					</h2>
					<p className="legal-paragraph">
						{translate("privacy.content.hosting1")}
					</p>
					<p className="legal-paragraph">
						{translate("privacy.content.hosting2")}
					</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">
						{translate("privacy.sections.security")}
					</h2>
					<p className="legal-paragraph">
						{translate("privacy.content.security")}
					</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">
						{translate("privacy.sections.retention")}
					</h2>
					<p className="legal-paragraph">
						{translate("privacy.content.retention")}
					</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">
						{translate("privacy.sections.rights")}
					</h2>
					<p className="legal-paragraph">
						{translate("privacy.content.rights")}
					</p>
					<ul className="legal-list">
						<li>{translate("privacy.content.rights.access")}</li>
						<li>{translate("privacy.content.rights.update")}</li>
						<li>{translate("privacy.content.rights.delete")}</li>
						<li>{translate("privacy.content.rights.export")}</li>
					</ul>
					<p className="legal-paragraph">
						{translate("privacy.content.rights.settings")}
					</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">
						{translate("privacy.sections.cookies")}
					</h2>
					<p className="legal-paragraph">
						{translate("privacy.content.cookies")}
					</p>
					<ul className="legal-list">
						<li>{translate("privacy.content.cookies.auth")}</li>
						<li>{translate("privacy.content.cookies.host")}</li>
					</ul>
					<p className="legal-paragraph">
						{translate("privacy.content.cookies.consent")}
					</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">
						{translate("privacy.sections.updates")}
					</h2>
					<p className="legal-paragraph">
						{translate("privacy.content.updates")}
					</p>
				</section>
			</div>
		</div>
	);
};

export default PrivacyPolicy;
